/**
 * Page-turn resolution for the FlashBook reader.
 *
 * Every theme declares how it wants pages to turn (`pageTurn` on its tokens):
 * `slide` pushes the next page in from the side, `fade` dips through the page
 * background, `none` swaps instantly. Themes written before the token existed
 * carry no value and keep the reader's historical slide.
 *
 * The reader itself can switch animations off in Settings, which overrides the
 * theme — that is the whole point of the preference, so it wins.
 */
export type FlashBookPageTurn = 'slide' | 'fade' | 'none'

export const DEFAULT_PAGE_TURN: FlashBookPageTurn = 'slide'

export function resolvePageTurn(
  token: FlashBookPageTurn | undefined,
  animationsEnabled: boolean,
): FlashBookPageTurn {
  if (!animationsEnabled) return 'none'
  return token ?? DEFAULT_PAGE_TURN
}
